<div class="notice-container">
    <p-card>
        <ng-template pTemplate="header">
            <div class="card-header">
                <h2>Confirmation par e-mail requise</h2>
            </div>
        </ng-template>

        <div class="notice-content">
            <i class="pi pi-envelope notice-icon"></i>
            <h3>Veuillez confirmer votre e-mail</h3>
            <p>Pour accéder à cette fonctionnalité, vous devez d'abord confirmer votre adresse e-mail.</p>
            <p>Vérifiez votre boîte de réception pour un lien de confirmation.</p>

            <div class="actions">
                <p-button label="Renvoyer l'e-mail de confirmation" icon="pi pi-refresh" (onClick)="resendEmail()"
                    styleClass="p-button-outlined">
                </p-button>
                <p-button label="Retour au tableau de bord" icon="pi pi-home" (onClick)="goToDashboard()">
                </p-button>
            </div>
        </div>
    </p-card>
</div>